import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {
    getAvtalByUserid, getAvtalByUserIdHeader,
    getProspetByUserIdHeader, getProspektByUserid,
    getOrderByUserID,getMoteByUserID,getKunderByUserID,
    getAktivitetByUserID,getEsigneringByUserID,
    GetHitCountRL,getRinglistor,getOrderByKedja,getCasesByKedja,
    onCloseKundToaster
} from 'actions'
import { Box, IconButton } from '@material-ui/core';
import Meny from "./Meny";
import {isEmpty,isUndefined} from 'lodash'
import {ArrowBack, ArrowBackIos} from '@material-ui/icons';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({ auth,accountsData,Order,Avtal,Event,Eisgnering,Ärende }) {
    const { authUser } = auth;
    const { Flags } = accountsData;
    const { Kedjaarenden } = Ärende;
    const {AvtalListByUser,ProspektListByUser,ProspektFilterOption,AvtalFilterOption} = Avtal;
    const { OrderListBUSER,OrderFilterOption }= Order
    const { EsigneringFilterOption }= Eisgnering
    const { AktiviterFilterOption }= Eisgnering
    const { EventListByUser,EventFilterOption }= Event
    const { MinaKunder,FilterOption }= accountsData
    return {
        authUser,Flags,AvtalListByUser,ProspektListByUser,OrderListBUSER,EventListByUser,
        MinaKunder,FilterOption,ProspektFilterOption,AvtalFilterOption,EventFilterOption,EsigneringFilterOption
        ,OrderFilterOption,AktiviterFilterOption,Kedjaarenden
    };
}


function mapDispatchToProps(dispatch) {
    return {
        getAvtalByUserid: (Afid,Filterstate,Userid) => dispatch(getAvtalByUserid(Afid,Filterstate,Userid)),
        getAvtalByUserIdHeader: (Afid,Filterstate,Userid,searchWord,type) => dispatch(getAvtalByUserIdHeader(Afid,Filterstate,Userid,searchWord,type)),
        getProspetByUserIdHeader: (Afid,Userid,ProspektFilterOption) => dispatch(getProspetByUserIdHeader(Afid,Userid,ProspektFilterOption)),
        getProspektByUserid: (Afid,Userid,ProspektFilterOption) => dispatch(getProspektByUserid(Afid,Userid,ProspektFilterOption)),
        getKunderByUserID: (Afid,Filterstate,MainUser) => dispatch(getKunderByUserID(Afid,Filterstate,MainUser)),
        getOrderByUserID: (Afid,Filterstate, userid,type) => dispatch(getOrderByUserID( Afid,Filterstate, userid,type)),
        getOrderByKedja: (Afid,type) => dispatch(getOrderByKedja( Afid,type)),
        getCasesByKedja: (Afid,userid,type) => dispatch(getCasesByKedja( Afid,userid,type)),
        getMoteByUserID: (Afid,Filterstate, userid) => dispatch(getMoteByUserID( Afid,Filterstate, userid)),
        getAktivitetByUserID: (Mainuserid,Afid, Filterstate) => dispatch(getAktivitetByUserID(Mainuserid, Afid, Filterstate)),
        getEsigneringByUserID: (Afid,Filterstate, userid) => dispatch(getEsigneringByUserID( Afid,Filterstate, userid)),
        GetHitCountRL: (Afid,RingLista) => dispatch(GetHitCountRL(Afid,RingLista)), 
        getRinglistor: (Afid,userid) => dispatch(getRinglistor(Afid,userid)), 
        onCloseKundToaster:()=>dispatch(onCloseKundToaster()), 
        dispatch
    };
}
class Navigation extends Component {
    getAvtalByUserid = () => {
        this.props.onCloseKundToaster()
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(isEmpty(this.props.AvtalListByUser)){
    //    this.props.getAvtalByUserIdHeader(Afid,this.props.AvtalFilterOption, userid)
    //    this.props.getAvtalByUserid(Afid,this.props.AvtalFilterOption, userid)
        }
    }
    getProspektByUserid = () => {
        this.props.onCloseKundToaster()
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(isEmpty(this.props.ProspektListByUser)){
     //   this.props.getProspetByUserIdHeader(Afid, userid,this.props.ProspektFilterOption)
     //   this.props.getProspektByUserid(Afid, userid,this.props.ProspektFilterOption)
        }
    }
    getOrderByUserID = () => {
        this.props.onCloseKundToaster()
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(isEmpty(this.props.OrderListBUSER)){
       this.props.getOrderByUserID(Afid,this.props.OrderFilterOption,userid,1)
        }
    }
    getOrderByKedja = () => {
        this.props.onCloseKundToaster()
        const Afid = this.props.authUser.user_Afid;
        if(isEmpty(this.props.OrderListBUSER)){
       this.props.getOrderByKedja(Afid,1)
        }
    }
    getCasesByKedja = () => {
        this.props.onCloseKundToaster()
        const Afid = this.props.authUser.user_Afid;
        const userid = this.props.authUser.user_id;
       if(isEmpty(this.props.arenden)){
     //   this.props.getCasesByKedja(Afid,user_id,1)
        }
    }
    getAktiviByUserid = () => {
        this.props.onCloseKundToaster()
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
     //   this.props.getAktivitetByUserID(userid,Afid,this.props.AktiviterFilterOption)        
    }
    getEsingeringByUserid = () => {
        this.props.onCloseKundToaster()
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
      //  this.props.getEsigneringByUserID(Afid,this.props.EsigneringFilterOption,userid)        
    }
    getCasesByUserid = () => {
        this.props.onCloseKundToaster()
        console.log("5")
    }
    getProjectsByUserid = () => {
        this.props.onCloseKundToaster()
        console.log("projekt")
    }
    getDialerByUserid = () => {
        const Afid = this.props.authUser.user_Afid;
        const userid = this.props.authUser.user_id;
      //  this.props.GetHitCountRL(Afid,[])
     //   this.props.getRinglistor(Afid,userid)

    }
    getOffertByUserid = () => {
        this.props.onCloseKundToaster()
        console.log("7")
    }
    getKunderByUserid = () => {
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.onCloseKundToaster()
     //   this.props.getKunderByUserID(Afid,this.props.FilterOption,userid)

    }
    getDashByUserid = () => {
        console.log("9")
    }
    getKundDataByAfid = () => {
        this.props.onCloseKundToaster()
        console.log("109")
    }
    getMoteByUserid = () => {
        this.props.onCloseKundToaster()
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(isEmpty(this.props.EventListByUser)){
     //   this.props.getMoteByUserID(Afid,this.props.EventFilterOption,userid,1)
        }
    }
    getFilerByUserid = () => {
        console.log("12")
    }
    goBack = () => {
        this.props.onCloseKundToaster()
        window.history.back();
    }
    render() {
        let { PathName, PageName, authUser } = this.props;
        if(PageName === "Lobby"){
            PageName= "Lobby"
        }
        if(PageName === "Dashboardprospekt"){
            PageName= "Översikt"
        }
        if(PageName === "DashboardBokning"){
            PageName= "Boka TV"
        }
        if(PageName === "DashboardStart"){
            PageName= "Dashboard"
        }
        const navData = parseInt(this.props.authUser.user_role) === 5?
        [
            { value: '/app/Order', label: <IntlMessages id="Order"/>, isActive: (authUser.user_SeeOrderList === 0) ? false : true, func: this.getOrderByUserID,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.OrderF ===1 )?true:false  },
            { value: '/app/Kunder', label: <IntlMessages id="Customers"/>, isActive: true, func: this.getKunderByUserid,Show:true } 
        ]
        :[
            { value: '/app/Kampanj', label: <IntlMessages id="Campaign"/>, isActive: isUndefined(this.props.Flags)?false:(this.props.Flags.MarketAutomation === 1 )?true:false, func: () => {},Show:isUndefined(this.props.Flags)?false:(this.props.Flags.MarketAutomation === 1 )?true:false},
            { value: '/app/Goava', label: "Goava", isActive: isUndefined(this.props.Flags)?false:(this.props.Flags.Goava === 1 )?true:false, func: () => {},Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Goava === 1 )?true:false},
            { value: '/app/Avtal', label: <IntlMessages id="Agreement"/>, isActive: (authUser.user_SeeContractFlag === 0)? false : true , func: this.getAvtalByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Avtal ===1 )?true:false },
            { value: '/app/Prospekt', label: <IntlMessages id="Prospectus"/>, isActive: true, func: this.getProspektByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Prospekt ===1 )?true:false },
            { value: '/app/Aktiviteter', label: <IntlMessages id="Activities"/>, isActive: true, func: this.getAktiviByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Aktiviteter ===1 )?true:false },
            { value: '/app/Order', label: <IntlMessages id="Order"/>, isActive: (authUser.user_SeeOrderList === 0) ? false : true, func: this.getOrderByUserID,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.OrderF ===1 )?true:false  },
            { value: '/app/Ärende', label: <IntlMessages id="Errand"/>, isActive: (authUser.user_SeeCasesList === 0) ? false : true, func: this.getCasesByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Arende ===1 )?true:false},
            { value: '/app/Projekt', label: <IntlMessages id="Project"/>, isActive: (authUser.user_SeeProjects === 0) ? false : true, func: this.getProjectsByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Projekt ===1 )?true:false},
            { value: '/app/Dialer', label: <IntlMessages id="Dialer"/>, isActive: (authUser.user_SeeDialer === 0) ? false : true, func: this.getDialerByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Dialer ===1 )?true:false  },
            { value: '/app/Offert', label: <IntlMessages id="Offer"/>, isActive: (authUser.user_CanSeeOffert === 0) ? false : true, func: this.getOffertByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Offert ===1 && this.props.Flags.Mallmodulen === 0)?true:false } ,
            { value: '/app/v2/Offert', label: <IntlMessages id="Offer"/>, isActive: (authUser.user_CanSeeOffert === 0) ? false : true, func: this.getOffertByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Mallmodulen ===1 )?true:false } ,
            { value: '/app/Kunder', label: <IntlMessages id="Customers"/>, isActive: true, func: this.getKunderByUserid,Show:true } ,
            { value: '/app/DashboardStart', label: <IntlMessages id="Dashboard"/>, isActive:(authUser.user_CanSeeDashboard === 0) ? false : true, func: this.getDashByUserid,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.Dashboard ===1 )?true:false } ,
            { value: '/app/KedjaOrder', label: <IntlMessages id="Order"/>, isActive: isUndefined(this.props.Flags)?false:(this.props.Flags.IsKedja === 1 )?true:false, func: this.getOrderByKedja,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.IsKedja === 1 )?true:false } ,
            { value: '/app/KedjaArende', label: <IntlMessages id="Errand"/>, isActive: isUndefined(this.props.Flags)?false:(this.props.Flags.IsKedja === 1 )?true:false, func: this.getCasesByKedja,Show:isUndefined(this.props.Flags)?false:(this.props.Flags.IsKedja === 1 )?true:false},
        ];
        return (
            <>
                <Box display="flex" bgcolor="white" zIndex={101} position={"relative"} p={0} height="40px">
                    <Box display="flex" alignItems="center">
                        {/* <i className="zmdi zmdi-eye zmdi-hc-fw" style={{ marginRight: '1rem' }} />
                        <span style={{ marginTop: '6px' }}>{PageName}</span> */}
                        <IconButton size="small" onClick={this.goBack} style={{margin: '0 3px 0 10px'}}>
                            <ArrowBackIos style={{fontSize: 16}} />
                        </IconButton>
                        <span>{PageName}</span> 
                    </Box>
                    {
                        isUndefined(this.props.Flags)?"":
                        parseInt(this.props.Flags.IsKedja) === 1?
                        <Box className="d-none d-sm-block" p={1} flexGrow={1} textAlign="right">
                        {
                        <Link
                        to='/app/KedjaOrder'
                        onClick={this.getOrderByKedja}
                        style={{ marginRight: '1rem' }}
                        className={(PageName === "KedjaOrder") ? "ActiveLink" : ""}
                        ><IntlMessages id="Order"/></Link>
                        }
                        {
                        <Link
                        to='/app/KedjaArende'
                        onClick={this.getCasesByKedja}
                        style={{ marginRight: '1rem' }}
                        className={(PageName === "KedjaArende") ? "ActiveLink" : ""}
                        ><IntlMessages id="Errand"/></Link>
                        }
                        </Box>
                        :
                    <>
                    <Box className="d-none d-sm-block" p={1} flexGrow={1} textAlign="right">
                        {
                            navData.map((object,index) =>
                            (object.Show === true) ?
                                (object.isActive === true) ?
                                    <Link
                                    key={index}
                                        to={object.value}
                                        onClick={object.func}
                                        style={{ marginRight: '1rem' }}
                                        className={(PageName === object.label) ? "ActiveLink" : ""}
                                    >{object.label}</Link>
                                    : ""
                                : ""
                            )}
                    </Box>
                    
                    <Box p={1}>
                    {
                        parseInt(this.props.authUser.user_role) === 5?"":
                        <Meny 
                        Flags={this.props.Flags}
                        authUser={this.props.authUser}
                        getAvtalByUserid={this.getAvtalByUserid}
                        getProspektByUserid={this.getProspektByUserid}
                        getAktiviByUserid={this.getAktiviByUserid}
                        getOrderByUserID={this.getOrderByUserID}
                        getOrderByKedja={this.getOrderByKedja}
                        getCasesByUserid={this.getCasesByUserid}
                        getProjectsByUserid={this.getProjectsByUserid}
                        getDialerByUserid={this.getDialerByUserid}
                        getOffertByUserid={this.getOffertByUserid}
                        getKunderByUserid={this.getKunderByUserid}
                        getDashByUserid={this.getDashByUserid}
                        getEsingeringByUserid={this.getEsingeringByUserid}
                        getMoteByUserid={this.getMoteByUserid}
                        getKundDataByAfid={this.getKundDataByAfid}
                        getFilerByUserid={this.getFilerByUserid}
                        />
                    }
                    </Box>
                    </>
                    }
                </Box>

            </>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);